import { render, staticRenderFns } from "./cv-tag.vue?vue&type=template&id=38153cfe&"
import script from "./cv-tag.vue?vue&type=script&lang=js&"
export * from "./cv-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports